import { render, staticRenderFns } from "./disciplinas-operacoes.vue?vue&type=template&id=def240d8&"
import script from "./disciplinas-operacoes.vue?vue&type=script&lang=js&"
export * from "./disciplinas-operacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports